import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=a2949a04&scoped=true"
import script from "./ReportSection.ts?vue&type=script&lang=ts&external"
export * from "./ReportSection.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportSection.scss?vue&type=style&index=0&id=a2949a04&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2949a04",
  null
  
)

export default component.exports